<template>
    <div id="sidebar" class="sidebar">
        <el-menu :default-active="computedURL" class="side-menu" background-color="#1e272c" text-color="#fff" :collapse="collapsed">
            <span v-for="(item, index) in menu_config" :key="index">
                <el-menu-item :index="item.route" :disabled="isDisabled(item)" v-if="show(item) && !item.hasOwnProperty('sub_menus')" @click="loadApp(item.route)">
                    <i :class="item.icon_class"></i>
                    <span slot="title">{{ $t('sidebar.' + item.title) }}</span>
                </el-menu-item>

                <el-submenu :index="String(index)" v-if="(show(item) && item.hasOwnProperty('sub_menus'))">
                    <template slot="title">
                        <i :class="item.icon_class"></i>
                        <span slot="title">{{ $t('sidebar.' + item.title) }}</span>
                    </template>

                    <el-menu-item v-for="(sub_item, index) in item.sub_menus" :key="index" :index="String(sub_item.route)" @click="loadApp(sub_item.route)">
                        <i :class="sub_item.icon_class"></i>
                       <span slot="title">{{ $t('sidebar.' + sub_item.title) }}</span>
                    </el-menu-item>
                </el-submenu>
            </span>
        </el-menu>
    </div>
</template>
<script>

    export default {
        data() {
            return {
                collapsed: false,
                menu_config: window.brandsafe_app_config.apps,
                cleanup_cookies: [
                    'bs_token',
                    'bs_token_valid_until',
                    'bs_customer_id',
                    'bs_departments',
                    'bs_language',
                    'bs_name',
                    'bs_profile',
                    'bs_role',
                    'bs_user_id',
                    'bs_username',
                    'bs_active_department_id'
                ],
                login_url: process.env.VUE_APP_LOGIN_URL,
            };
        },

        created() {
            this.checkForCookies();
        },

        computed: {
            computedURL() {
              if (location.hash && location.hash !== "#/") {
                return location.pathname + location.hash;
              }

                return location.pathname;
            }
        },

        methods: {
            checkForCookies() {
                let customerId=0;
                try{
                    customerId = parseInt(this.$cookies.get('bs_customer_id'));
                    if([47,48].includes(customerId)){
                        this.login_url+='/apoteket';
                    }
                }catch (e){
        
                }

                if (!this.$cookies.isKey("bs_active_department_id") || !this.$cookies.isKey("bs_customer_id") || !this.$cookies.isKey("bs_user_id")) {
                    this.logOut(false, true);
                }
            },

            async logOut(automatic = false, is_cookie_error = false) {
                this.cleanUp().then(val => {
                    if (automatic) {
                        location.href = this.login_url + '?redirect=' + location.href;
                    }
                    
                    location.href = this.login_url + (is_cookie_error ? '?cookie_error=true' : '');
                });
            },

            async cleanUp() {
                this.cleanup_cookies.forEach(async cookie => {
                    // await this.deleteCookie(cookie);

                    if (process.env.VUE_APP_ENV === 'production') {
                        this.$cookies.remove(cookie, null, process.env.VUE_APP_WRAPPER_COOKIE_DOMAIN);
                    }
                    else if (process.env.VUE_APP_ENV === 'development') {
                        this.$cookies.remove(cookie, null);
                    }
                });

                localStorage.removeItem('active_account');
                localStorage.removeItem('user');

                return true;
            },

            loadApp(app) {
                if (app === '/admin/roles') {
                    alert(this.$t('not_available_in_demo'));
                    return false;
                }

                let url = app.startsWith('http') ? app : window.location.origin + app;

                window.location.href = url;
            },

            isDisabled(app) {
                if (!app.hasOwnProperty('disabled'))
                {
                    return false;
                }

                return app.disabled;

            },

            show(app) {
                if (!app.hasOwnProperty('show')) {
                    return true;
                }

                return app.show;
            }
        }
    }
</script>


<style lang="less">
    .side-menu {
        .el-menu {
            //border: none !important;
            //border-right: none !important;
        }

        .el-menu-item {
            font-size: 16px !important;
            font-weight: 400;
            color: #fff !important;
            padding-left: 10px !important;
            height: 40px !important;
            line-height: 42px !important;
            min-width: 100% !important;
        }

        .el-submenu {
            font-size: 15px !important;
            font-weight: 400;
            color: #fff !important;

            .el-submenu__title {
                padding-left: 10px !important;
                font-size: 16px !important;
                font-weight: 400;
                height: 40px !important;
                line-height: 42px !important;
            }

            .el-menu-item {
                padding-left: 40px !important;
            }
        }

        .el-menu-item.is-active {
            color: yellowgreen !important;
            border-left: solid;
        }

        .icon-margin {
            margin-top: -3px;
            margin-right: 20px;
        }

        .is-disabled {
            //border-bottom: 1px solid #fff;
            border-top: 1px solid #fff;
            color: #fff !important;
        }
    }
    .side-menu:not(.el-menu--collapse) {
        height: calc(100vh - 50px);
        position: absolute !important; 
        width: 250px !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
    }

    .sidebar {
        font-family: 'Cabin', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased !important;
        -moz-osx-font-smoothing: grayscale !important;
    }

    .el-menu--horizontal>.el-menu-item {
        font-size: 15px !important;
    }
</style>